// import React, { useEffect } from "react";

// const PrivacyPolicy = () => {
//  useEffect(() => {
//   window.scrollTo(0, 0);
// }, []);


//   return (
//     <div style={styles.container} className="background-clr">
//       <h1 style={styles.title}>Privacy Policy</h1>

//       <p style={styles.date}>
//         <strong>Effective Date:</strong> 15th December 2025
//       </p>

//       <p>
//         Thank you for choosing <strong>DigiDoc</strong> ("we," "our," or "us").
//         Your privacy is important to us. This Privacy Policy explains how we
//         collect, use, and protect your information when you use the DigiDoc
//         mobile application ("App").
//       </p>

//       <Section title="1. Information We Collect">
//         <ul>
//           <li>
//             <strong>Personal Information:</strong> Name, age, gender, contact
//             details (phone number, email), and profile photo.
//           </li>
//           <li>
//             <strong>Health Information:</strong> Medical history, prescriptions,
//             treatment plans, appointments, and doctor communications.
//           </li>
//           <li>
//             <strong>Device & Usage Data:</strong> Device type, IP address, app
//             usage statistics, and error reports.
//           </li>
//           <li>
//             <strong>Location Data:</strong> With your permission, to help locate
//             nearby doctors or clinics.
//           </li>
//         </ul>
//       </Section>

//       <Section title="2. How We Use Your Information">
//         <ul>
//           <li>Book and manage your appointments with healthcare providers.</li>
//           <li>Provide reminders for medicines, treatments, or follow-ups.</li>
//           <li>Deliver digital prescriptions and reports.</li>
//           <li>Maintain your health records securely.</li>
//           <li>Improve app performance and user experience.</li>
//           <li>Comply with legal obligations.</li>
//         </ul>
//       </Section>

//       <Section title="3. How We Share Your Information">
//         <ul>
//           <li>
//             With doctors and healthcare providers you book through DigiDoc.
//           </li>
//           <li>
//             With third-party service providers (e.g., cloud storage, analytics)
//             under strict confidentiality agreements.
//           </li>
//           <li>When required by law or to protect our rights.</li>
//         </ul>
//       </Section>

//       <Section title="4. Data Security">
//         <p>
//           We use industry-standard security measures, including encryption, to
//           protect your data. However, no system is 100% secure, so we encourage
//           you to use strong passwords and keep your device secure.
//         </p>
//       </Section>

//       <Section title="5. Your Rights">
//         <ul>
//           <li>Access, update, or delete your personal data.</li>
//           <li>
//             Withdraw consent at any time (may affect app functionality).
//           </li>
//           <li>Request a copy of the data we hold about you.</li>
//         </ul>
//       </Section>

//       <Section title="6. Data Retention">
//         <p>
//           We retain your data only as long as needed to provide our services or
//           comply with legal obligations.
//         </p>
//       </Section>

//       <Section title="7. Contact Us">
//         <p>
//           <strong>Email:</strong>{" "}
//           <a href="mailto:support@digidoc.co.in">
//             support@digidoc.co.in
//           </a>
//         </p>
//         <p>
//           <strong>Address:</strong> S2, 21, Srinivasa Nagar, Kandanchavadi,
//           Perungudi, Chennai, Tamil Nadu 600096.
//         </p>
//       </Section>
//     </div>
//   );
// };

// /* 🔹 Reusable Section Component */
// const Section = ({ title, children }) => (
//   <div style={styles.section}>
//     <h2 style={styles.heading}>{title}</h2>
//     {children}
//   </div>
// );

// /* 🔹 Simple Styling */
// const styles = {
//   container: {
//     // maxWidth: "900px",
//     margin: "40px auto",
//     padding: "20px 40px",
//     fontFamily: "Arial, sans-serif",
//     lineHeight: 1.7,
//     color: "#333",
//   },
//   title: {
//     textAlign: "center",
//     marginBottom: "10px",
//     color: "#4da9ff",
    
//   },
//   date: {
//     textAlign: "center",
//     marginBottom: "30px",
//     color: "#555",
//   },
//   section: {
//     marginBottom: "25px",
//   },
//   heading: {
//     marginBottom: "10px",
//     color: "#4da9ff",  	
//   },
// };

// export default PrivacyPolicy;

import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={styles.container} className="background-clr">
      <h1 style={styles.title}>Privacy Policy</h1>

      <p style={styles.date}>
        <strong>Effective Date:</strong> 15th December 2025
      </p>

      <p>
        <strong>DigiDoc</strong> is a digital healthcare platform owned,
        operated, and managed by{" "}
        <strong>Digitivity Solutions Private Limited</strong> ("Digitivity
        Solutions", "Company", "we", "our", or "us").
      </p>

      <p>
        At Digitivity Solutions Private Limited, we are committed to protecting
        your privacy and ensuring the security of your personal and health
        information. This Privacy Policy explains how we collect, use, disclose,
        and safeguard your information when you access or use the DigiDoc mobile
        application, website, and related services (collectively, the
        "Services").
      </p>

      <p>
        By using DigiDoc, you agree to the collection and use of information in
        accordance with this Privacy Policy.
      </p>

      <Section title="1. Information We Collect">
        <h4  style={styles.subHeading}>Personal Information</h4>
        <p>We may collect information such as:</p>
        <ul>
          <li>Full name</li>
          <li>Age and date of birth</li>
          <li>Gender</li>
          <li>Mobile number</li>
          <li>Email address</li>
          <li>Profile photograph</li>
          <li>Emergency contact information (where applicable)</li>
        </ul>

        <h4  style={styles.subHeading}>Health Information</h4>
        <p>To provide healthcare-related services, we may collect:</p>
        <ul>
          <li>Medical history</li>
          <li>Prescriptions</li>
          <li>Laboratory reports</li>
          <li>Treatment plans</li>
          <li>Appointment history</li>
          <li>Medication schedules</li>
          <li>Doctor communications</li>
          <li>Other health-related information voluntarily provided by you</li>
        </ul>

        <h4  style={styles.subHeading}>Device &amp; Usage Information</h4>
        <p>We automatically collect certain information including:</p>
        <ul>
          <li>Device type and operating system</li>
          <li>Device identifiers</li>
          <li>IP address</li>
          <li>App usage statistics</li>
          <li>Crash reports</li>
          <li>Log files</li>
          <li>Diagnostic information</li>
        </ul>

        <h4  style={styles.subHeading}>Location Information</h4>
        <p>
          With your explicit permission, DigiDoc may access your device location
          to help you discover nearby healthcare providers, clinics,
          pharmacies, or hospitals.
        </p>
      </Section>

      <Section title="2. How We Use Your Information">
        <p>Digitivity Solutions Private Limited uses your information to:</p>

        <ul>
          <li>Create and manage your DigiDoc account.</li>
          <li>Schedule and manage appointments with healthcare providers.</li>
          <li>
            Deliver medicine reminders, treatment reminders, and follow-up
            notifications.
          </li>
          <li>Store and organize your medical records securely.</li>
          <li>
            Enable healthcare professionals to provide better care through
            DigiDoc.
          </li>
          <li>
            Improve the performance, functionality, and user experience of the
            Services.
          </li>
          <li>Provide customer support.</li>
          <li>
            Detect fraud, prevent misuse, and maintain platform security.
          </li>
          <li>Comply with applicable legal and regulatory requirements.</li>
        </ul>
      </Section>

      <Section title="3. How We Share Your Information">
        <p>We do not sell your personal information.</p>

        <p>
          Your information may be shared only in the following circumstances:
        </p>

        <ul>
          <li>
            With doctors, hospitals, clinics, pharmacies, laboratories,
            caregivers, or healthcare providers authorized by you through
            DigiDoc.
          </li>
          <li>
            With trusted third-party service providers such as cloud hosting,
            analytics, communication, payment, and infrastructure providers who
            assist us in operating the Services under strict confidentiality
            obligations.
          </li>
          <li>
            With government authorities, regulators, courts, or law enforcement
            agencies when required by applicable law.
          </li>
          <li>
            In connection with a merger, acquisition, restructuring, or sale of
            business assets, subject to appropriate privacy safeguards.
          </li>
        </ul>
      </Section>

      <Section title="4. Data Security">
        <p>
          Digitivity Solutions Private Limited implements industry-standard
          administrative, technical, and organizational safeguards to protect
          your information, including encryption, secure cloud infrastructure,
          access controls, and regular security monitoring.
        </p>

        <p>
          While we strive to protect your data, no electronic storage or
          internet transmission can be guaranteed to be completely secure. Users
          are encouraged to use strong passwords and protect access to their
          devices.
        </p>
      </Section>

      <Section title="5. Your Rights">
        <p>Subject to applicable laws, you have the right to:</p>

        <ul>
          <li>Access your personal information.</li>
          <li>Correct or update inaccurate information.</li>
          <li>Request deletion of your account and personal data.</li>
          <li>Withdraw previously provided consent (where applicable).</li>
          <li>Request a copy of the personal data we maintain about you.</li>
          <li>
            Raise concerns regarding the processing of your personal
            information.
          </li>
        </ul>

        <p>
          Please note that withdrawing consent or deleting certain information
          may affect your ability to use some DigiDoc features.
        </p>
      </Section>

      <Section title="6. Data Retention">
        <p>
          We retain personal and health information only for as long as
          necessary to provide the Services, fulfill contractual obligations,
          comply with applicable laws, resolve disputes, and enforce our
          agreements.
        </p>
      </Section>

      <Section title="7. Changes to this Privacy Policy">
        <p>
          Digitivity Solutions Private Limited may update this Privacy Policy
          periodically. Any material changes will be communicated through the
          DigiDoc application or other appropriate channels. Continued use of
          the Services after such updates constitutes acceptance of the revised
          Privacy Policy.
        </p>
      </Section>

      <Section title="8. Contact Us">
        <p>
          If you have any questions, concerns, or requests regarding this
          Privacy Policy or the handling of your information, please contact:
        </p>

        <p>
          <strong>Digitivity Solutions Private Limited</strong>
          <br />
          <strong>Product:</strong> DigiDoc
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:support@digidoc.co.in">
            support@digidoc.co.in
          </a>
          <br />
          <strong>Registered Address:</strong>
          <br />
          S2, 21, Srinivasa Nagar,
          <br />
          Kandanchavadi, Perungudi,
          <br />
          Chennai, Tamil Nadu – 600096,
          <br />
          India.
        </p>
      </Section>
    </div>
  );
};

/* Reusable Section Component */
const Section = ({ title, children }) => (
  <div style={styles.section}>
    <h2 style={styles.heading}>{title}</h2>
    {children}
  </div>
);

/* Styling */
const styles = {
  container: {
    margin: "40px auto",
    padding: "20px 40px",
    fontFamily: "Arial, sans-serif",
    lineHeight: 1.7,
    color: "#333",
  },
  title: {
    textAlign: "center",
    marginBottom: "10px",
    color: "#4da9ff",
  },
  date: {
    textAlign: "center",
    marginBottom: "30px",
    color: "#555",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    marginBottom: "10px",
    color: "#4da9ff",
  },
  subHeading: {
    display: "block",
    width: "100%",
    textAlign: "left",
    marginTop: "20px",
    marginBottom: "10px",
    color: "#333",
    fontSize: "18px",
    fontWeight: "600",
  },
};

export default PrivacyPolicy;